













































import { Component, Inject, Vue } from 'vue-property-decorator'
import SwipePreview from '../swipePreview.vue'
import VideoPanel from '@/app/shared/components/video/index.vue'
import { Swipe, SwipeItem, Icon } from 'vant'
import { namespace } from 'vuex-class'
const shopHomeModule = namespace('shopHome')
// import defaultAvatar from '../../assets/image/IMG_7215@3x.png'

interface IshopDetail {
  storeImg: string
  storeImgArr: string[]
  storeHeadImg: string
  storeName: string
  storeCategory: string
  distance: string
  distanceKm: string
  storeVideoUrl: string
  storeVideoPicture: string
  verificationNum: number
  albums: any[]
}

@Component({
  components: {
    SwipePreview,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Icon.name]: Icon,
    VideoPanel
  }
})
export default class Description extends Vue {
  @Inject({ default: null })
  headImgTrackParams!: any

  showVideo = false
  mediumText = '图片'
  indexSwipe = 1
  canPlay = true
  showSwipe = true

  @shopHomeModule.State shopDetail!: IshopDetail
  @shopHomeModule.State shopYuer!: boolean

  bannerPreviewShow = false
  bannerPreviewItems: any[] = []
  bannerPreviewIndex = 0
  // get defaultAvatarH() {
  //   return defaultAvatar
  // }

  get hasVideo() {
    return this.shopDetail.storeVideoUrl ? true : false
  }

  playingStatus(val: any) {
    this.showVideo = val
  }

  isAndroidsWX() {
    console.log(this.shopDetail)

    const u = window.navigator.userAgent
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
    const isWX = /micromessenger/i.test(u)
    return isAndroid && isWX
  }

  clickType() {
    const swipe = this.$refs.swipe as any
    if (this.mediumText === '图片') {
      swipe?.swipeTo(1)
    } else {
      swipe?.swipeTo(0)
    }
  }

  videoStatus(status: any) {
    if (this.isAndroidsWX()) {
      if (status) {
        this.showSwipe = false
      } else {
        this.showSwipe = true
      }
    }
  }

  handleChange(index: number) {
    this.indexSwipe = index + 1
    if (this.hasVideo) {
      if (index > 0) {
        this.mediumText = '视频'
      } else {
        this.mediumText = '图片'
      }
    }
    if (!this.isAndroidsWX() && this.hasVideo) {
      if (index !== 0) {
        this.canPlay = false
      } else {
        this.canPlay = true
      }
    }
  }

  get showStoreName() {
    return this.shopDetail && this.shopDetail.storeName /*  && this.shopDetail.storeName.slice(0, 80) */
  }
  get showDistance() {
    return parseInt(this.shopDetail && this.shopDetail.distanceKm && this.shopDetail.distanceKm) > 60 ? '>60km' : this.shopDetail && this.shopDetail.distanceKm && '距您' + this.shopDetail.distanceKm
  }
  get shopHeader() {
    const imgUrl = this.shopDetail
      ? (this.shopDetail.storeImgArr &&
          this.shopDetail.storeImgArr.map(item => {
            return {
              imgUrl: item
            }
          })) || [{ imgUrl: this.shopDetail.storeHeadImg }] || [{ imgUrl: require('@assets/images/icon_default_store_img.png') }]
      : ''
    console.log(imgUrl)

    return imgUrl
  }
  get shopAlbums() {
    if (this.shopYuer) {
      return []
    }
    const albums = []
    if (this.shopDetail && Array.isArray(this.shopDetail.albums)) {
      for (const album of this.shopDetail.albums) {
        Array.isArray(album.list) && albums.push(...album.list)
      }
    }
    return albums
  }
  get showBanner() {
    const middle = Math.ceil(this.shopAlbums.length / 2)
    const bannerData = [...this.shopAlbums.slice(middle), ...this.shopHeader, ...this.shopAlbums.slice(0, middle)]
    return bannerData
  }
  get initialBanner() {
    return Math.floor(this.shopAlbums.length / 2)
  }

  get coverImage() {
    if (this.shopDetail.storeImg) return this.shopDetail.storeImg
    if (this.shopAlbums.length && this.shopAlbums.length > 0) {
      return this.shopAlbums[0].imgUrl
    }
    return this.shopDetail.storeVideoPicture || ''
  }

  async created() {
    // const {} = this.shopDetail
  }

  /* 预览轮播图 */
  previewBanner(index: number) {
    this.bannerPreviewItems = this.showBanner
    this.bannerPreviewShow = true
    this.bannerPreviewIndex = index
    this.headImgTrackParams && this.$newClickTracker(this.headImgTrackParams)
  }
  /* 查看商家相册 */
  showAlbum() {
    if (this.shopAlbums.length === 0) {
      this.previewBanner(0)
    } else {
      this.$router.push({
        name: 'shopAlbum',
        query: {
          ...this.$route.query,
          refresh: 'no',
          cmd: 'share',
          sharetype: '0'
        }
      })
    }
  }
}
